export default __webpack_public_path__ + "static/media/regular.be77b388.woff";